import React from "react";
import type { PageData } from "../shared/types";
import { Markdown } from "../markdown/Markdown";
import { HubPage, IntroductionPage, OperationPage, WebhookEventsPage } from "./ReferencePages";
import { TaskCategoryPage, TaskIndexPage, TaskPage } from "./TaskPages";
import { ChangelogPage } from "./ChangelogPage";
import { VocabulariesPage } from "./VocabulariesPage";

/** One page's content, by the kind the build gave it (`PageKind`). */
export const PageBody = ({ page }: { page: PageData }) => {
  switch (page.kind) {
    case "markdown": {
      const body = (page as PageData<"markdown">).body;

      return <Markdown markdown={body.markdown} code={body.code} />;
    }
    case "operation":
      return <OperationPage body={(page as PageData<"operation">).body} />;
    case "hub":
      return <HubPage body={(page as PageData<"hub">).body} />;
    case "introduction":
      return <IntroductionPage body={(page as PageData<"introduction">).body} />;
    case "webhookEvents":
      return <WebhookEventsPage body={(page as PageData<"webhookEvents">).body} />;
    case "taskIndex":
      return <TaskIndexPage body={(page as PageData<"taskIndex">).body} />;
    case "taskCategory":
      return <TaskCategoryPage body={(page as PageData<"taskCategory">).body} />;
    case "task":
      return <TaskPage body={(page as PageData<"task">).body} />;
    case "changelog":
      return <ChangelogPage body={(page as PageData<"changelog">).body} />;
    case "vocabularies":
      return <VocabulariesPage body={(page as PageData<"vocabularies">).body} />;
    default:
      return null;
  }
};

/** Kinds whose own layout fills the right column (a sticky code panel, a tag filter): no "On this page". */
export const OWN_RIGHT_COLUMN = new Set<PageData["kind"]>(["operation", "changelog"]);
